export function getApiBaseUrl() {
  // return 'https://tfamapp.org';
  // return 'http://127.0.0.1:3000';
  // return 'https://tfam.rideawave.tw'
  if (process.env.NODE_ENV === 'production') {
    return 'https://tfamapp.org';
  } else {
    return 'http://127.0.0.1:3000';
  }
}

export function getGCPStorageUrl() {
  // return 'https://tfam.rideawave.tw/api/attachments/tfam-storage/download'
  // return 'https://storage.googleapis.com/tfam-storage';
  if (process.env.NODE_ENV === 'production') {
    return 'https://storage.googleapis.com/tfam-storage';
  } else {
    return 'http://127.0.0.1:3000/api/attachments/tfam-storage/download';
  }
}
